import { render, staticRenderFns } from "./number-form.vue?vue&type=template&id=2f39b37c&scoped=true"
import script from "./number-form.vue?vue&type=script&lang=ts"
export * from "./number-form.vue?vue&type=script&lang=ts"
import style0 from "./number-form.vue?vue&type=style&index=0&id=2f39b37c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f39b37c",
  null
  
)

export default component.exports